import axios from "axios";
import {API_BASE_URL} from "../constants/api";
import {ACCESS_TOKEN} from "../constants/auth";

const EmissionService = {};
EmissionService.getTrends = async function (emissionName, fromTimestamp, toTimestamp, avgType) {
    return axios({
        method: "get",
        url: API_BASE_URL + "/api/emission/trends",
        params: {
            emissionName,
            fromTimestamp,
            toTimestamp,
            avgType
        },
        headers: {
            "Content-Type": "application/json",
            // 'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

EmissionService.getEmissions = async function () {
    return axios({
        method: "get",
        url: API_BASE_URL + "/api/emission/get",
        headers: {
            "Content-Type": "application/json",
            // 'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

EmissionService.getEmissionsActualPageable = async function (page, limit) {
    return axios({
        method: "get",
        url: API_BASE_URL + "/api/emission/get/actual",
        params: {
            page: page - 1,
            limit,
        },
        headers: {
            "Content-Type": "application/json",
            // 'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

EmissionService.getTrendsPageable = async function (page, limit, emissionName, fromTimestamp, toTimestamp) {
    return axios({
        method: "get",
        url: API_BASE_URL + "/api/emission/trends",
        params: {
            page: page - 1,
            limit,
            emissionName,
            fromTimestamp,
            toTimestamp
        },
        headers: {
            "Content-Type": "application/json",
            // 'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

EmissionService.getDashboardSummary = async function () {
    return axios({
        method: "get",
        url: API_BASE_URL + "/api/emission/dashboard/summary",
        headers: { "Content-Type": "application/json" }
    });
}

EmissionService.getDashboardChart = async function (limit = 200) {
    return axios({
        method: "get",
        url: API_BASE_URL + "/api/emission/dashboard/chart",
        params: { limit },
        headers: { "Content-Type": "application/json" }
    });
}

EmissionService.getDashboardChartRange = async function (fromTimestamp, toTimestamp) {
    return axios({
        method: "get",
        url: API_BASE_URL + "/api/emission/dashboard/chart/range",
        params: { fromTimestamp, toTimestamp },
        headers: { "Content-Type": "application/json" }
    });
}

EmissionService.getArchiveDashboardSummary = async function () {
    return axios({
        method: "get",
        url: API_BASE_URL + "/api/emission/archive/dashboard/summary",
        headers: { "Content-Type": "application/json" }
    });
}

export default EmissionService;